import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const docFileUrl = (id) => (id ? `${API}/documents/${id}/file?auth=${localStorage.getItem("praniq_token")}` : null);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("praniq_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function loginPathForCurrentLocation() {
  const p = window.location.pathname;
  if (p.startsWith("/pro")) return "/pro/login";
  if (p.startsWith("/patient")) return "/patient/login";
  if (p.startsWith("/admin")) return "/admin/login";
  if (p.startsWith("/ops")) return "/ops/login";
  return "/login";
}

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const onAuthCall = url.includes("/auth/login") || url.includes("/auth/register");
    if (status === 401 && !onAuthCall && localStorage.getItem("praniq_token")) {
      localStorage.removeItem("praniq_token");
      localStorage.setItem("praniq_session_ended", "expired");
      const loginPath = loginPathForCurrentLocation();
      if (!window.location.pathname.endsWith("/login")) {
        window.location.assign(`${loginPath}?expired=1`);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
